<template>
  <div class="main-inner">
    <div class="inner-header">
      <img src="@/assets/img/logo.svg" class="logo" />
      <span>打卡森林 | 帮你养成好习惯</span>
      <span class="desc">产品介绍</span>
      <span class="contact" @click="onClickContact()">联系我们</span>
    </div>
    <div class="inner-title">
      <img src="@/assets/img/logo.svg" class="logo" />
      <span class="title">打卡森林</span>
      <span class="desc">打卡森林是一款生活的好帮手，能帮助你养成好习惯。</span>
    </div>
    <div class="content" style="margin-top: 261px;">
      <div class="desc-content" style="margin-left:0;margin-right:auto;">
        <span class="content1">每日签到打卡</span>
        <span class="content2">帮你养成好习惯</span>
      </div>
      <img src="@/assets/img/desc1.svg">
    </div>
    <div class="content" style="margin-top:166px;">
      <img src="@/assets/img/desc2.svg">
      <div class="desc-content" style="margin-left:auto;margin-right:0;">
        <span class="content1">7天养成一棵大树</span>
        <span class="content2">收集可爱树种 7天养成大树</span>
      </div>
    </div>
    <div class="content" style="margin-top:170px;">
      <div class="desc-content" style="margin-left:0;margin-right:auto;">
        <span class="content1">单个习惯独立森林</span>
        <span class="content2">记录打卡频率 回顾目标进度</span>
      </div>
      <img src="@/assets/img/desc3.svg">
    </div>
    <div class="content" style="margin-top:122px;">
      <img src="@/assets/img/desc4.svg">
      <div class="desc-content" style="margin-left:auto;margin-right:0;">
        <span class="content1">创造你的独特森林</span>
        <span class="content2">每棵树都是你坚持的见证</span>
      </div>
    </div>
    <div class="inner-footer">
      <span class="footer1">© 2021 fbee.site, all rights reserved    京ICP备18035449号</span>
      <a href="https://prdimages.growup.link/forestConfig/senlin_privacyPolicy.html" target="_blank" >隐私政策</a>
      <span style="margin-left:10px;margin-right:10px;">|</span>
      <a href="https://prdimages.growup.link/forestConfig/senlin_userAgreement.html" target="_blank" >用户协议</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Main',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    onClickContact () {
      this.$router.push({
        name: 'Contact'
      })
    }
  }
}
</script>

<style lang='scss'>

.main-inner {
  min-width: 1440px;
  height: 3000px !important;
  display: flex !important;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  background-image: url('../assets/img/bg.png');
  background-repeat: no-repeat;
  background-size:100% 100%;
  align-items: center;

  .inner-header {
    height: 40px;
    width: 1010px;
    display: flex;
    color: #FFF;
    align-items: center;
    margin-top: 15px;
    font-size: 20px;
    line-height: 26px;
    user-select: none;

    .logo {
      width: 40px;
      height: 40px;
      margin-right: 20px;
      align-items: center;
    }

    .desc {
      cursor: pointer;
      font-weight: bold;
      margin-right: 0px;
      margin-left: auto;
    }

    .contact {
      cursor: pointer;
      margin-right: 0px;
      margin-left: 78px;
    }
  }

  .inner-title {
    width: 1010px;
    display: flex;
    flex-direction: column;
    margin-top: 105px;
    user-select: none;
    color: #FFF;

    .logo {
      width: 150px;
      height: 150px;
    }

    .title {
      font-size: 55px;
      line-height: 73px;
      margin-top: 30px;
    }

    .desc {
      margin-top: 5px;
      font-size: 26px;
      line-height: 45px;
      width: 456px;
    }
  }

  .content {
    width: 946px;
    height: 410px;
    display: flex;
    align-items: center;
  }

  .desc-content {
    display: flex;
    flex-direction: column;

    .content1 {
      color: #000;
      font-size: 55px;
      line-height: 73px;
    }

    .content2 {
      color: #686D76;
      font-size: 26px;
      line-height: 45px;
    }
  }

  .inner-footer {
    display: flex;
    color: #000;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    margin-top: auto;
    margin-bottom: 30px;

    .footer1 {
      text-align: center;
      width: 445px;
    }

    a {
      color: #000;
      text-decoration: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/Main.vue